export const FETCHER_SETTINGS_CATALOGUE_QUERY_ID = "5764903193280512";
export const FETCHER_SETTINGS_DETAILS_QUERY_ID = "5746891375509504";
export const FETCHER_SETTINGS_BRAND_TRACE_QUERY_ID = "5705268310573056";
export const FETCHER_SETTINGS_DEV_LEVEL = "dev";
export const FETCHER_SETTINGS_DEV_ITEM_ID = "2";

//for taking first websiteSharedUid from userData Permission (/me EP)
export function getFirstWebsiteSharedUid(userData: any): string | null {
  const websitePermissions: any[] = userData?.data?.website_permissions || [];
  const first = websitePermissions[0];
  return first ? (Object.keys(first)[0] ?? null) : null;
}
//for taking first dimension from userData (/me EP)
// export function getFirstDimension(userData: any): string | null {
//   const dimensions: any[] = userData?.data?.dimensions || [];
//   return typeof dimensions[0] === "string" ? dimensions[0] : null;
// }
